import cage from "@/assets/sprites/objects/cage.svg";
import chestOpened from "@/assets/sprites/objects/chest-opened.svg";
import chest from "@/assets/sprites/objects/chest.svg";
import gold from "@/assets/sprites/objects/gold.svg";
import hotSpring from "@/assets/sprites/objects/hot-spring.svg";
import lotteryGate from "@/assets/sprites/objects/lottery-gate.svg";
import lotteryWheel from "@/assets/sprites/objects/lottery-wheel.svg";
import lotteryWheelDisc from "@/assets/sprites/objects/lottery-wheel-disc.svg";
import lotteryWheelFrame from "@/assets/sprites/objects/lottery-wheel-frame.svg";
import dice from "@/assets/sprites/objects/dice.svg";
import diceTrigger from "@/assets/sprites/objects/dice-trigger.svg";
import summonCage from "@/assets/sprites/objects/summon-cage.svg";
import teleport from "@/assets/sprites/objects/teleport.svg";
import waterThrone from "@/assets/sprites/objects/water-throne.svg";
import waterOffering from "@/assets/sprites/objects/water-offering.svg";
import woodenDoorOpen from "@/assets/sprites/objects/wooden-door-open.svg";
import woodenDoor from "@/assets/sprites/objects/wooden-door.svg";
import clayBoulder from "@/assets/sprites/objects/clay-boulder.svg";
import clayGate from "@/assets/sprites/objects/clay-gate.svg";
import blacksmithAnvil from "@/assets/sprites/objects/blacksmith/anvil.svg";
import blacksmithForge from "@/assets/sprites/objects/blacksmith/forge.svg";
import blacksmithSupplies from "@/assets/sprites/objects/blacksmith/supplies.svg";
import blacksmithToolRack from "@/assets/sprites/objects/blacksmith/tool-rack.svg";
import blacksmithWorkbench from "@/assets/sprites/objects/blacksmith/workbench.svg";
import caveRock from "@/assets/sprites/objects/cave-rock.svg";
import caveGems from "@/assets/sprites/objects/cave-gems.svg";
import miningDoor from "@/assets/sprites/objects/mining-door.svg";
import miningKey from "@/assets/sprites/objects/mining-key.svg";
import miningKeyMissing from "@/assets/sprites/objects/mining-key-missing.svg";
import miningRock from "@/assets/sprites/objects/mining-rock.svg";
import miningRock2 from "@/assets/sprites/objects/mining-rock-2.svg";
import miningRock3 from "@/assets/sprites/objects/mining-rock-3.svg";
import miningRock4 from "@/assets/sprites/objects/mining-rock-4.svg";
import miningRock5 from "@/assets/sprites/objects/mining-rock-5.svg";
import cobweb from "@/assets/sprites/objects/cobweb.svg";
import portalRune from "@/assets/sprites/objects/portal-rune.svg";
import shopRug from "@/assets/sprites/objects/shop-rug.svg";
import shopShelf from "@/assets/sprites/objects/shop-shelf.svg";
import springReeds from "@/assets/sprites/objects/spring-reeds.svg";
import potionCauldron from "@/assets/sprites/objects/potionmaster/cauldron.svg";
import potionShelf from "@/assets/sprites/objects/potionmaster/shelf.svg";
import potionTable from "@/assets/sprites/objects/potionmaster/table.svg";
import gardenTree from "@/assets/sprites/objects/tower/tree.svg";
import gardenFountain from "@/assets/sprites/objects/tower/fountain.svg";
import gardenStatue from "@/assets/sprites/objects/tower/statue.svg";
import towerWall from "@/assets/sprites/objects/tower/wall.svg";
import towerDoor from "@/assets/sprites/objects/tower/door.svg";
import gardenWater from "@/assets/sprites/objects/tower/water.svg";
import gardenFlowers from "@/assets/sprites/objects/tower/flowers.svg";
import gardenBench from "@/assets/sprites/objects/tower/bench.svg";
import forgeGate from "@/assets/sprites/objects/forge-gate.svg";
import forgeRecipeEmpty from "@/assets/sprites/objects/forge-recipe-empty.svg";
import mapTable from "@/assets/sprites/objects/map-table.svg";
import anglerNet from "@/assets/sprites/objects/angler-net.svg";
import graveCracked from "@/assets/sprites/objects/decor/graveyard/cracked-grave.svg";
import graveBonePile from "@/assets/sprites/objects/decor/graveyard/bone-pile.svg";
import graveCandles from "@/assets/sprites/objects/decor/graveyard/funeral-candles.svg";
import graveFence from "@/assets/sprites/objects/decor/graveyard/iron-fence.svg";
import graveRoyalBanner from "@/assets/sprites/objects/decor/graveyard/royal-crypt-banner.svg";
import goblinPatchedPlanks from "@/assets/sprites/objects/decor/goblin/patched-planks.svg";
import goblinBanner from "@/assets/sprites/objects/decor/goblin/clan-banner.svg";
import goblinTarget from "@/assets/sprites/objects/decor/goblin/archery-target.svg";
import goblinRopeCoil from "@/assets/sprites/objects/decor/goblin/rope-coil.svg";
import drownedKelp from "@/assets/sprites/objects/decor/drowned/kelp.svg";
import drownedCoral from "@/assets/sprites/objects/decor/drowned/coral.svg";
import drownedMast from "@/assets/sprites/objects/decor/drowned/broken-mast.svg";
import drownedBarnacles from "@/assets/sprites/objects/decor/drowned/barnacles.svg";
import drownedOozeSlick from "@/assets/sprites/objects/decor/drowned/ooze-slick.svg";
import drownedPylon from "@/assets/sprites/objects/decor/drowned/abyssal-pylon.svg";
import rustmirePipeStraight from "@/assets/sprites/objects/decor/rustmire/pipe-straight.svg";
import rustmirePipeCorner from "@/assets/sprites/objects/decor/rustmire/pipe-corner.svg";
import rustmirePipeJunction from "@/assets/sprites/objects/decor/rustmire/pipe-junction.svg";
import rustmireValve from "@/assets/sprites/objects/decor/rustmire/valve-wheel.svg";
import rustmireGrate from "@/assets/sprites/objects/decor/rustmire/floor-grate.svg";
import rustmirePuddle from "@/assets/sprites/objects/decor/rustmire/rust-puddle.svg";
import rustmireLamp from "@/assets/sprites/objects/decor/rustmire/warning-lamp.svg";
import beachPalm from "@/assets/sprites/objects/decor/beach/palm-tree.svg";
import beachShells from "@/assets/sprites/objects/decor/beach/shells.svg";
import beachDriftwood from "@/assets/sprites/objects/decor/beach/driftwood.svg";
import earthRopeAnchor from "@/assets/sprites/objects/decor/earth/rope-anchor.svg";
import earthSewerGrate from "@/assets/sprites/objects/decor/earth/sewer-grate.svg";
import earthLeakingPipe from "@/assets/sprites/objects/decor/earth/leaking-pipe.svg";
import earthRatNest from "@/assets/sprites/objects/decor/earth/rat-nest.svg";
import earthAntMound from "@/assets/sprites/objects/decor/earth/ant-mound.svg";
import earthEggCluster from "@/assets/sprites/objects/decor/earth/egg-cluster.svg";
import earthResinPatch from "@/assets/sprites/objects/decor/earth/resin-patch.svg";
import earthBurialUrn from "@/assets/sprites/objects/decor/earth/burial-urn.svg";
import earthFossil from "@/assets/sprites/objects/decor/earth/fossil.svg";
import earthPotteryShards from "@/assets/sprites/objects/decor/earth/pottery-shards.svg";
import earthLavaVent from "@/assets/sprites/objects/decor/earth/lava-vent.svg";
import earthBasaltSpire from "@/assets/sprites/objects/decor/earth/basalt-spire.svg";
import earthEmberPile from "@/assets/sprites/objects/decor/earth/ember-pile.svg";
import cartographerScrolls from "@/assets/sprites/objects/decor/npc/scroll-stack.svg";
import cartographerCompass from "@/assets/sprites/objects/decor/npc/compass-rose.svg";
import cartographerTripod from "@/assets/sprites/objects/decor/npc/survey-tripod.svg";
import anglerBaitBarrel from "@/assets/sprites/objects/decor/npc/bait-barrel.svg";
import anglerFishRack from "@/assets/sprites/objects/decor/npc/fish-rack.svg";
import potionHerbs from "@/assets/sprites/objects/decor/npc/herb-bundle.svg";
import potionBottleCrate from "@/assets/sprites/objects/decor/npc/bottle-crate.svg";
import gardenHedge from "@/assets/sprites/objects/decor/tower/hedge.svg";
import gardenLeaves from "@/assets/sprites/objects/decor/tower/fallen-leaves.svg";
import gardenLantern from "@/assets/sprites/objects/decor/tower/garden-lantern.svg";
import towerBanner from "@/assets/sprites/objects/decor/tower/tower-banner.svg";
import miningRails from "@/assets/sprites/objects/decor/mining/rails.svg";
import miningMinecart from "@/assets/sprites/objects/decor/mining/minecart.svg";
import miningTimber from "@/assets/sprites/objects/decor/mining/timber-support.svg";
import miningLantern from "@/assets/sprites/objects/decor/mining/mine-lantern.svg";
import miningOreVein from "@/assets/sprites/objects/decor/mining/ore-vein.svg";
import miningRubble from "@/assets/sprites/objects/decor/mining/rubble.svg";

export const objectSprites = {
  cage,
  chest,
  chestOpened,
  gold,
  hotSpring,
  lotteryGate,
  lotteryWheel,
  lotteryWheelDisc,
  lotteryWheelFrame,
  dice,
  diceTrigger,
  summonCage,
  teleport,
  waterThrone,
  waterOffering,
  woodenDoor,
  woodenDoorOpen,
  clayBoulder,
  clayGate,
  blacksmithAnvil,
  blacksmithForge,
  blacksmithSupplies,
  blacksmithToolRack,
  blacksmithWorkbench,
  caveRock,
  caveGems,
  miningDoor,
  miningKey,
  miningKeyMissing,
  miningRock,
  miningRock2,
  miningRock3,
  miningRock4,
  miningRock5,
  cobweb,
  portalRune,
  shopRug,
  shopShelf,
  springReeds,
  potionCauldron,
  potionShelf,
  potionTable,
  gardenTree,
  gardenFountain,
  gardenStatue,
  towerWall,
  towerDoor,
  gardenWater,
  gardenFlowers,
  gardenBench,
  forgeGate,
  forgeRecipeEmpty,
  mapTable,
  anglerNet,
  graveCracked,
  graveBonePile,
  graveCandles,
  graveFence,
  graveRoyalBanner,
  goblinPatchedPlanks,
  goblinBanner,
  goblinTarget,
  goblinRopeCoil,
  drownedKelp,
  drownedCoral,
  drownedMast,
  drownedBarnacles,
  drownedOozeSlick,
  drownedPylon,
  rustmirePipeStraight,
  rustmirePipeCorner,
  rustmirePipeJunction,
  rustmireValve,
  rustmireGrate,
  rustmirePuddle,
  rustmireLamp,
  beachPalm,
  beachShells,
  beachDriftwood,
  earthRopeAnchor,
  earthSewerGrate,
  earthLeakingPipe,
  earthRatNest,
  earthAntMound,
  earthEggCluster,
  earthResinPatch,
  earthBurialUrn,
  earthFossil,
  earthPotteryShards,
  earthLavaVent,
  earthBasaltSpire,
  earthEmberPile,
  cartographerScrolls,
  cartographerCompass,
  cartographerTripod,
  anglerBaitBarrel,
  anglerFishRack,
  potionHerbs,
  potionBottleCrate,
  gardenHedge,
  gardenLeaves,
  gardenLantern,
  towerBanner,
  miningRails,
  miningMinecart,
  miningTimber,
  miningLantern,
  miningOreVein,
  miningRubble,
} as const;
